import {ProductWithNodes} from '../../../types';

type Props = {
  storefrontProduct: ProductWithNodes;
};

export default function Material({storefrontProduct}: Props) {
  const metafields = storefrontProduct.metafields;
  return (
    <div className="mt-8 text-sm">
      {metafields?.map(
        (metafield) =>
          metafield?.key === 'materiell' && (
            <p
              key={metafield.key}
              dangerouslySetInnerHTML={{__html: metafield.value}}
            />
          ),
      )}
    </div>
  );
}
